import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';

@Component({
  selector: 'referentiel-new',
  templateUrl: './referentiel-new.fragment.html',
  styleUrls: ['./referentiel-new.fragment.scss', '../modal.fragment.scss'],
})

export class ReferentielNewFragment implements OnInit {
  public formGroup: FormGroup;
  public nomTable: string;
  public header = '';
  public errorMessage = '';
  public isEdit = false;
  public refreshStream: Subject<any>;
  public referentiel: Referentiel;
  public isSubmitDisabled: boolean = false;

  @Output() public closeEmitter = new EventEmitter();

  constructor(
    private _formBuilder: FormBuilder,
    public viewContainerRef: ViewContainerRef,
    public modalService: ModalService,
    private referentielSvc: ReferentielService
  ) { }

  ngOnInit(): void {
    if (this.nomTable=="RefTypeConsultation") { // si la table est le refTypeConsultation.
      const initialColor = this.referentiel && this.referentiel.sublibelle ? `#${this.referentiel.sublibelle}` : '#FFFFFF'; // Couleur par défaut ou recuperer
      this.formGroup = this._formBuilder.group({
        libelle: ['', Validators.required],
        sublibelle: ['', Validators.required],
        backgroundColor: [initialColor, Validators.required] // Valeur par défaut
      });
        // Synchroniser les changements de backgroundColor avec sublibelle
      this.formGroup.get('backgroundColor').valueChanges.subscribe(color => {
        this.formGroup.get('sublibelle').setValue(color.replace('#', ''));
      });
    }else{
      this.formGroup = this._formBuilder.group({
        libelle: ['', Validators.required]
      });
    }
    
    if (this.referentiel && this.referentiel.id) {
      this.isEdit = true;
    }
    if (this.referentiel && this.referentiel.libelle) {
      this.formGroup.controls['libelle'].setValue(this.referentiel.libelle);
    }
  }

  public async onSubmit(): Promise<void> {
    this.isSubmitDisabled = true;
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      try {
        if (this.isEdit) {
          this.referentiel.libelle = this.formGroup.controls['libelle'].value;
          if (this.referentiel.sublibelle) {
            this.referentiel.sublibelle = this.formGroup.controls['sublibelle'].value;
          }
          await this.referentielSvc.updateRefOneToUser(this.nomTable, this.referentiel);
        } else {
          this.referentiel = { id: '', libelle: this.formGroup.controls['libelle'].value };
          if (this.formGroup.controls['sublibelle']) {
            this.referentiel.sublibelle = this.formGroup.controls['sublibelle'].value;
          }
          await this.referentielSvc.addRefOneToUser(this.nomTable, this.referentiel);
        }
        this.refreshStream.next();
        this.closeRechercheModal();
      } catch (error) {
        console.error(error);
        this.errorMessage = error;
      }
    } else {
      this.isSubmitDisabled = false;
    }
  }

  public closeRechercheModal(): void {
    this.closeEmitter.emit(null);
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
